import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}


/**
 * Return preferred image params based on Network Information API
 * Falls back to sensible defaults when API is not available.
 */
export function getPreferredImageParams() {
  try {
    const nav = navigator.connection || {};
    const saveData = nav.saveData;
    const type = (nav.effectiveType || '').toLowerCase();

    if (saveData || type.includes('2g') || type === 'slow-2g') {
      return { width: 256, height: 256, quality: 0.7 };
    }
    if (type.includes('3g')) {
      return { width: 384, height: 384, quality: 0.8 };
    }
    return { width: 512, height: 512, quality: 0.9 };
  } catch (e) {
    return { width: 512, height: 512, quality: 0.9 };
  }
}
